<template>
  <div class>
    <div class="jm-white-container mb-5">
      <div class="col-lg-10 mx-auto">
        <div class="row">
          <div class="col-12">
            <div
              class="h5 mb-3"
            >Cinema: {{currentCinemaIndex == 0 ? 1 : currentCinemaIndex}}/{{noOfCinemas}}</div>
          </div>
          <!-- OPERATION TIME -->
          <div class="col-md-12">
            <div class="row">
              <div v-if="cinemas.length > 1" class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <b-dropdown
                    :text="selectedCinema.label"
                    variant="dropdown-curve-lg bg-theme-light"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(cinema,cinemaIndex) in cinemas"
                      :key="cinemaIndex"
                      @click="onSelectHandler(cinema)"
                    >{{ cinema.cine_name }}</b-dropdown-item>
                  </b-dropdown>
                  <Tooltip :title="`Select Your Cinema`"  />
                </div>
                <!-- <p class="error_msg">Invalid Entry</p> -->
              </div>

              <div class="col-md-6 mb-4">
                <date-picker
                  v-model="cinema_config.cine_operation_start_time"
                  lang="en"
                  type="time"
                  format="hh:mm a"
                  :minute-step="1"
                  class="time_picker"
                  placeholder="Operation Start Time"
                  @input="onclose($event)"
                  name="operationstime"
                  id="operationstime"
                  v-validate="'required'"
                ></date-picker>

                <p
                  v-if="submitted && errors.has('operationstime')"
                  class="error_msg"
                >{{ errors.first('operationstime') }}</p>
              </div>

              <!-- <div class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material w-100">
                    <input
                      v-model="cinema_config.cine_operation_start_time"
                      type="text"
                      id="ost"
                      placeholder="Operation Start Time"
                      name="Operation Start Time"
                      v-validate="{required: 'required', regex:/[0-9]\:[0-9][0-9]$/}"
                    />
                    <label for="ost">Operation Start Time</label>
                  </div>
                  <Tooltip :title="Tooltip content" />
                </div>
                <p v-if="submitted && errors.has('Operation Start Time')" class="error_message">
                  {{ errors.first(`${'Operation Start Time'}`)}}
                </p>
              </div>-->

              <div class="col-md-6 mb-4">
                <date-picker
                  v-model="cinema_config.cine_operation_end_time"
                  lang="en"
                  type="time"
                  format="hh:mm a"
                  :minute-step="1"
                  class="time_picker"
                  placeholder="Operation End Time"
                  @input="onclose($event)"
                  name="operationetime"
                  id="operationetime"
                  v-validate="'required'"
                ></date-picker>
                <p
                  v-if="submitted && errors.has('operationetime')"
                  class="error_msg"
                >{{ errors.first('operationetime') }}</p>
              </div>
              <!-- <div class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material w-100">
                    <input
                      v-model="cinema_config.cine_operation_end_time"
                      type="text"
                      id="oet"
                      placeholder="Operation End Time"
                      name="Operation End Time"
                      v-validate="{required: 'required', regex:/[0-9]\:[0-9][0-9]$/}"
                    />
                    <label for="oet">Operation End Time</label>
                  </div>
                  <Tooltip :title="Tooltip content" />
                </div>
                <p v-if="submitted && errors.has('Operation End Time')" class="error_message">
                  {{ errors.first(`${'Operation End Time'}`)}}
                </p>
              </div>-->
            </div>
          </div>

          <!-- CLEANING TIME -->
          <div class="col-md-12 mb-4">
            <div class="row align-items-center">
              <div class="col-md-2">Cleaning Time:</div>
              <div class="col-md-10 d-flex align-items-center">
                <div class="input-material mr-1" style="width:100px;">
                  <input
                    v-model="cinema_config.cine_cleaning_time_in_mins"
                    type="text"
                    id="time"
                    placeholder="."
                    name="Cleaning Time"
                    v-validate="'required|numeric'"
                  />
                  <label for="time">Time</label>
                </div>
                <div>Minutes</div>
              </div>
              <p v-if="submitted && errors.has('Cleaning Time')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${'Cleaning Time'}`)}}
              </p>
            </div>
          </div>

          <!-- ADVERTISEMENT TIME -->
          <div class="col-md-12 mb-4">
            <div class="row align-items-center">
              <div class="col-md-2">Advertisement Time:</div>
              <div class="col-md-10 d-flex align-items-center">
                <div class="input-material mr-1" style="width:100px;">
                  <input
                    type="text"
                    v-model="cinema_config.cine_setting_ads_time_in_mins"
                    id="time1"
                    placeholder="."
                    name="Advertisement Time"
                    v-validate="'required|numeric'"
                  />
                  <label for="time1">Time</label>
                </div>
                <div>Minutes</div>
              </div>
              <p v-if="submitted && errors.has('Advertisement Time')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${'Advertisement Time'}`)}}
              </p>
            </div>
          </div>

          <!-- CUTOFF TIME  -->
          <div class="col-md-12 mb-4">
            <div class="row align-items-center">
              <div class="col-md-2">Cutoff Time:</div>
              <div class="col-md-10 d-flex align-items-center">
                <div class="input-material mr-1" style="width:100px;">
                  <input
                    v-model="cinema_config.cine_cutoff_time_in_mins"
                    type="text"
                    id="time2"
                    placeholder="."
                    name="Cutoff Time"
                    v-validate="'required|numeric'"
                  />
                  <label for="time2">Time</label>
                </div>
                <div>Minutes &nbsp; after movie starts</div>
              </div>
              <p v-if="submitted && errors.has('Cutoff Time')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${'Cutoff Time'}`)}}
              </p>
            </div>
          </div>

          <!-- SEAT RELEASE TIME -->
          <div class="col-md-12 mb-4">
            <div class="row align-items-center">
              <div class="col-md-2">Seat-Release Time:</div>
              <div class="col-md-10 d-flex align-items-center">
                <div class="input-material mr-1" style="width:100px;">
                  <input
                    v-model="cinema_config.cine_seat_release_time_in_mins"
                    type="text"
                    id="time12"
                    name="Seat Release"
                    v-validate="'required|numeric'"
                    placeholder="."
                  />
                  <label for="time12">Time</label>
                </div>
                <div>Minutes &nbsp; before movie starts</div>
              </div>
              <p v-if="submitted && errors.has('Seat Release')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${'Seat Release'}`)}}
              </p>
            </div>
          </div>

          <!-- INTERVAL TIME -->
          <div class="col-md-12 mb-4">
            <div class="row align-items-center">
              <div class="col-md-2">Interval Time:</div>
              <div class="col-md-10 d-flex align-items-center">
                <div class="input-material mr-1" style="width:100px;">
                  <input
                    v-model="cinema_config.cine_interval_time_in_mins"
                    type="text"
                    id="time12"
                    name="Interval Time"
                    v-validate="'required|numeric'"
                    placeholder="."
                  />
                  <label for="time12">Time</label>
                </div>
                <div>Minutes</div>
              </div>
              <p v-if="submitted && errors.has('Interval Time')" class="error_message">
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${'Interval Time'}`)}}
              </p>
            </div>
          </div>
          <!-- 
          <ol class="d-flex" style="list-style:none">
            <li
              class="px-5"
              :style="{color:  current_cinema_index == noc ? 'green':''}"
              v-for="(noc,nocKey) in parseInt(noOfCinemas)"
              :key="nocKey"
            >{{ noc }}</li>
          </ol>-->

          <!-- NAVIGATION -->
          <div class="col-md-12 mt-5 text-center">
            <div class="row">
              <router-link to="add-cinema-master" class="btn-outline-blue-lg col">Back</router-link>
              <!-- <router-link
                v-if="isUpdate"
                to="add-screens"
                class="btn-outline-blue-lg col mx-2"
              >Next</router-link>-->
              <router-link to="setup-add-user" class="btn-outline-blue-lg col mx-2">Skip</router-link>
              <router-link to v-on:click.native="onSubmit()" class="btn-blue-lg col">Next</router-link>
              <!-- <router-link
                v-if="current_cinema_index > 1 && parseInt(noOfCinemas) > 1"
                to="setup-add-user"
                class="btn-blue-lg w-25"
              >Skip</router-link>-->
            </div>
            <!--  -->
            <!-- finance-configuration  -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";
import saveState from "vue-save-state";
import DatePicker from "vue2-datepicker";
import moment from "moment-timezone";

export default {
  components: { DatePicker },
  // name: " ",
  mixins: [saveState],
  data() {
    return {
      submitted: false,
      BtnText: "Add User",
      isUpdate: false,
      selectedCinema: {
        label: "Select Cinema",
      },
      current_cinema_index: 1,
      cinema_config: {
        cine_id: window.localStorage.getItem("CURRENT_CINEMA_ID") || 1,
        cine_operation_start_time: "",
        cine_operation_end_time: "",
        cine_cleaning_time_in_mins: "",
        cine_setting_ads_time_in_mins: "",
        cine_seat_release_time_in_mins: "",
        cine_cutoff_time_in_mins: "",
        cine_interval_time_in_mins: "",
      },
    };
  },
  computed: {
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    cinemas() {
      return this.$store.getters.CINEMAS;
    },
    currentCinemaIndex() {
      return this.$store.getters.currentCinemaIndex;
    },
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: "Cinema Configuration",
      };
    },
    onSelectHandler: function (cinema) {
      this.selectedCinema.label = cinema.cine_name;
      this.cinema_config.cine_id = cinema.cine_id;
    },
    ResetForm: function () {
      this.cinema_config = {
        cine_id: window.localStorage.getItem("CURRENT_CINEMA_ID") || 1,
        cine_operation_start_time: "",
        cine_operation_end_time: "",
        cine_cleaning_time_in_mins: "",
        cine_setting_ads_time_in_mins: "",
        cine_seat_release_time_in_mins: "",
        cine_cutoff_time_in_mins: "",
        cine_setting_is_active: "Y",
      };
    },
    onclose: function (e) {},

    onSubmit: function () {
      this.submitted = true;

      function format24Hours(date) {
        let newVal = date;
        let finalVal = moment(newVal).format("H:mm");
        return finalVal;
      }

      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.cinema_config.cine_operation_start_time = format24Hours(
            this.cinema_config.cine_operation_start_time
          );

          this.cinema_config.cine_operation_end_time = format24Hours(
            this.cinema_config.cine_operation_end_time
          );

          let payload = {
            ...this.cinema_config,
          };
          let configHeaders = {
            headers: {
              "content-type": "application/json",
              Authorization: window.localStorage.getItem("AUTH_KEY"),
            },
          };
          console.log("payload ::::", payload);
          SetupService.AddCinemaConfig(payload, configHeaders)
            .then((result) => {
              const { data } = result;
              if (data.status) {
                this.isUpdate = true;
                // this.BtnText = "Update";
                //   if (
                //     this.current_cinema_index ==
                //     parseInt(this.$store.getters.NO_OF_CINEMAS)
                //   ) {
                // this.$router.push({
                //   path: "add-screens"
                // });
                this.$router.push({
                  path: "setup-add-user",
                });
                // } else {
                //   this.ResetForm();
                //   this.current_cinema_index++;
                // }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              this.$toasted.show(err);

              console.log("err :", err);
            });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/cinemaConfiguration.vue